import styled from 'styled-components';

import { Button, TextButton } from '@xing-com/button';
import { ModalPage as ModalPageBase } from '@xing-com/modal-page';
import {
  xdlColorBackgroundQuaternary,
  spaceXXL,
  spaceXL,
  spaceL,
  spaceS,
  cornerRadius3XL,
  xdlColorBackgroundSecondary,
  dropShadowS,
  xdlColorBorderSoft,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

import { CARD_HEIGHT, CARD_WIDTH } from '../constants';

const ModalPage = styled(ModalPageBase)`
  background-color: ${xdlColorBackgroundQuaternary};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;

  && {
    margin: 0;
    padding: 20px;
  }
`;

const CardContainer = styled.div`
  background-color: ${xdlColorBackgroundSecondary};
  display: flex;
  flex-direction: column;
  width: ${CARD_WIDTH}px;
  height: ${CARD_HEIGHT}px;
  padding: ${spaceXL};
  border-radius: ${cornerRadius3XL};
  box-shadow: ${dropShadowS};
  border: 2px solid transparent;
  border: 2px solid ${xdlColorBorderSoft};
  margin-bottom: ${spaceXXL};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${CARD_WIDTH}px;
`;
const ReminderLabel = styled(Headline)`
  margin-bottom: ${spaceS};
  text-align: center;
`;
const ReminderLabelDescription = styled(BodyCopy)`
  margin-bottom: ${spaceXL};
  text-align: center;
`;

const ReminderCta = styled(Button)`
  margin-bottom: ${spaceL};
`;

const CloseButton = styled(TextButton)``;

export {
  ModalPage,
  CardContainer,
  ReminderLabel,
  ReminderLabelDescription,
  ReminderCta,
  CloseButton,
  Content,
};
